var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useMemo, useRef, useState, } from 'react';
const DEFAULT_ITEM_HEIGHT = 56;
const DEFAULT_CONTAINER_HEIGHT = DEFAULT_ITEM_HEIGHT * 10;
export function useVirtualization({ containerRef, data, isVirtual, scrollToIndex, }) {
    _react_refresh_temp_1();
    // Using the second row as a reference to get row height
    const itemRef = useRef(null);
    const itemHeight = itemRef.current?.clientHeight || DEFAULT_ITEM_HEIGHT;
    const numberOfItems = data.length;
    const containerHeight = containerRef.current?.clientHeight || DEFAULT_CONTAINER_HEIGHT;
    const numberOfVisibleItems = Math.floor(containerHeight / itemHeight);
    // A row the table has to open on can sit outside the first window. Both
    // the window and the container start at it, or it is never rendered and so
    // never focused or scrolled to.
    const targetIndex = scrollToIndex && scrollToIndex > 0 ? scrollToIndex : 0;
    const initialScrollTop = targetIndex * itemHeight;
    const [scrollTop, setScrollTop] = useState(() => initialScrollTop);
    const [startIndex, setStartIndex] = useState(() => targetIndex - numberOfVisibleItems);
    const [endIndex, setEndIndex] = useState(() => Math.min(numberOfItems - 1, Math.floor((scrollTop + containerHeight) / itemHeight) +
        numberOfVisibleItems));
    const hasScrolledToIndexRef = useRef(false);
    useEffect(() => {
        if (!isVirtual ||
            hasScrolledToIndexRef.current ||
            !targetIndex ||
            !containerRef.current) {
            return;
        }
        hasScrolledToIndexRef.current = true;
        containerRef.current.scrollTop = initialScrollTop;
    }, [containerRef, initialScrollTop, isVirtual, targetIndex]);
    useEffect(() => {
        const newStart = Math.floor(scrollTop / itemHeight) - numberOfVisibleItems;
        const newEnd = Math.min(numberOfItems - 1, Math.floor((scrollTop + containerHeight) / itemHeight) +
            numberOfVisibleItems);
        if (newStart < startIndex || newEnd > endIndex) {
            setStartIndex(newStart);
            setEndIndex(newEnd);
        }
    }, [
        containerHeight,
        endIndex,
        itemHeight,
        numberOfItems,
        numberOfVisibleItems,
        scrollTop,
        startIndex,
    ]);
    const slicedData = useMemo(() => {
        return data.slice(Math.max(startIndex, 0), endIndex + 1);
    }, [endIndex, data, startIndex]);
    const onContainerScroll = (e) => {
        const newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop + (numberOfVisibleItems / 2) * itemHeight <
            scrollTop ||
            newScrollTop - (numberOfVisibleItems / 2) * itemHeight > scrollTop) {
            setScrollTop(e.currentTarget.scrollTop);
        }
    };
    if (isVirtual) {
        return {
            itemHeight,
            itemRef,
            numberOfVisibleItems,
            numberOfItems,
            onContainerScroll,
            slicedData,
            startIndex,
        };
    }
    else {
        return {
            itemHeight: null,
            itemRef: null,
            numberOfVisibleItems: null,
            numberOfItems: null,
            onContainerScroll: null,
            slicedData: null,
            startIndex: null,
        };
    }
}
_react_refresh_temp_1(useVirtualization, "O1/3rZqCuAhc/jaAjv7u93Cmvek=");
